<iframe loading=lazy [src]="videoUrl" frameborder="0"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
  class="e2e-iframe-trusted-src"></iframe>